import { useParams } from "react-router-dom";
import Single from "../../components/Events/Single";
import ViewItem from "../../components/Templates/ViewItem";
import useEventContainer from "../../containers/Events/useEventContainer";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";

import { Routes } from "../../routes/Routes";

const Event: React.FC = () => {
  const { eventId } = useParams();

  const {
    event,

    pageLoading,

    handleDelete,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  } = useEventContainer(eventId);

  const { events } = useContent().pages;
  const { isRTL } = useRTL();

  return (
    <ViewItem
      name={events.event}
      pageLoading={pageLoading}
      item={event}
      editPath={Routes.getEditEvent(eventId)}
      handleDelete={handleDelete}
      openDeleteDialog={openDeleteDialog}
      setOpenDeleteDialog={setOpenDeleteDialog}
      deleteLoading={loading}
      itemRef="title"
      Card={<Single event={event} />}
    />
  );
};

export default Event;
